import * as React from "react";
import ButtonNavigation from "../BottomNavigation/bottomNavigation";
import BOListTemplates from "../DocumentTemplates/bolisttemplates";
import DocuTemplates from "../DocumentTemplates/docutemplates";
import {displayCountryDesc} from "../Services/services";
import {useFileUploadInfoData} from "../Contexts/fileUploadInfoProvider";

interface Props {
    selectedPage: string;
    country: string;
    selectedOption: string;
    setSelectedPage: React.Dispatch<React.SetStateAction<string>>;
    setSelectedCountry: React.Dispatch<React.SetStateAction<string>>;
    setSelectedOption: React.Dispatch<React.SetStateAction<string>>;
    warnings: string[];
}

const FileUploadVerification: React.FC<Props> = (props) => {
    const {
        selectedPage,
        country,
        selectedOption,
        warnings,
        setSelectedPage,
        setSelectedCountry,
        setSelectedOption,
    } = props;

    const {fileUploadData} = useFileUploadInfoData();

    return (
        <div>
            <p>Upload Beneficial Owner List - Step 5 of 5</p>
            <div style={{marginTop: "10px"}}>
                {displayCountryDesc(country, selectedOption)}
            </div>
            <div className="inline" style={{marginRight: "15px"}}>
                <BOListTemplates country={country}/>
                <DocuTemplates country={country}/>
            </div>
            <div className="inline" style={{width: "65%"}}>
                <p className="subTitle"> File Upload Verification</p>
                <p>
                    Please verify the information below then click 'Continue'. To change
                    anything use the 'Back' button at the bottom of the page.
                </p>
                <p style={{fontWeight: "bold"}}>My Contact Information</p>
                <hr/>
                <div className="inline" style={{width: "50%"}}>
                    Name:
                </div>
                <div className="inline" style={{width: "50%"}}>
                    {fileUploadData.salutation} {fileUploadData.firstName}{" "}
                    {fileUploadData.lastName}
                </div>
                <br/>
                <div className="inline" style={{width: "50%"}}>
                    Organization:
                </div>
                <div className="inline" style={{width: "50%"}}>
                    {fileUploadData.customerOrg}
                </div>
                <br/>
                <div className="inline" style={{width: "50%"}}>
                    Telephone:
                </div>
                <div className="inline" style={{width: "50%"}}>
                    {fileUploadData.phoneNbr}
                </div>
                <br/>
                <div className="inline" style={{width: "50%"}}>
                    Email:
                </div>
                <div className="inline" style={{width: "50%"}}>
                    {fileUploadData.email}
                </div>
                <br/>
                <p style={{fontWeight: "bold"}}>
                    Confirmation message will be sent to
                </p>
                <hr/>
                <div className="inline" style={{width: "50%"}}>
                    Email:
                </div>
                <div className="inline" style={{width: "50%"}}>
                    {fileUploadData.email}
                </div>
                <br/>
                <p style={{fontWeight: "bold"}}>Clearstream Account Information</p>
                <hr/>
                <div className="inline" style={{width: "50%"}}>
                    Account number:
                </div>
                <div className="inline" style={{width: "50%"}}>
                    {fileUploadData.acctNbr}
                </div>
                <br/>
                <div className="inline" style={{width: "50%"}}>
                    Platform:
                </div>
                <div className="inline" style={{width: "50%"}}>
                    {fileUploadData.platform}
                </div>
                <br/>
                <p style={{fontWeight: "bold"}}>Payment details </p>
                <hr/>
                {fileUploadData.country === "Germany" && (
                    <>
                        <div className="inline" style={{width: "50%"}}>
                            Tax Year:
                        </div>
                        <div className="inline" style={{width: "50%"}}>
                            {fileUploadData.taxYear}
                        </div>
                        <br/>
                    </>
                )}
                {fileUploadData.country !== "Germany" && (
                    <>
                        {fileUploadData.commonCode && (
                            <>
                                <div className="inline" style={{width: "50%"}}>
                                    Common Code:
                                </div>
                                <div className="inline" style={{width: "50%"}}>
                                    {fileUploadData.commonCode}
                                </div>
                                <br/>
                            </>
                        )}
                        {fileUploadData.isin && (
                            <>
                                <div className="inline" style={{width: "50%"}}>
                                    ISIN:
                                </div>
                                <div className="inline" style={{width: "50%"}}>
                                    {fileUploadData.isin}
                                </div>
                                <br/>
                            </>
                        )}
                        <div className="inline" style={{width: "50%"}}>
                            Security Name:
                        </div>
                        <div className="inline" style={{width: "50%"}}>
                            {fileUploadData.securityName}
                        </div>
                        <br/>
                        <div className="inline" style={{width: "50%"}}>
                            CORP ID:
                        </div>
                        <div className="inline" style={{width: "50%"}}>
                            {fileUploadData.corpId}
                        </div>
                        <br/>
                        <div className="inline" style={{width: "50%"}}>
                            Record Date:
                        </div>
                        <div className="inline" style={{width: "50%"}}>
                            {fileUploadData.recordDate}
                        </div>
                        <br/>
                        <div className="inline" style={{width: "50%"}}>
                            Payment Date:
                        </div>
                        <div className="inline" style={{width: "50%"}}>
                            {fileUploadData.paymentDate}
                        </div>
                        <br/>
                        <div className="inline" style={{width: "50%"}}>
                            Total Holding:
                        </div>
                        <div className="inline" style={{width: "50%"}}>
                            {fileUploadData.totalHolding}
                        </div>
                        <br/>
                    </>
                )}

                <p style={{fontWeight: "bold"}}>B.O. List File </p>
                <hr/>
                <div className="inline" style={{width: "50%"}}>
                    File:
                </div>
                <div className="inline" style={{width: "50%"}}>
                    {fileUploadData.attachedFileName}
                </div>
                <div className="inline" style={{width: "50%"}}>
                    Size:
                </div>
                <div className="inline" style={{width: "50%", paddingBottom: "20px"}}>
                    {Number(fileUploadData.attachedFileSize) / 1000} kB
                </div>

                {fileUploadData.returnedReferenceCode === "FileContainsVirus" &&
                    <>
                        <p style={{fontWeight: "bold", color: "red"}}>Errors</p>
                        <hr style={{backgroundColor: "red", height: "1px", border: "none"}}/>
                        <div className="inline" style={{color: "red"}}>
                            File has not been sent because the file contains a virus.
                        </div>
                        <br/>
                    </>
                }

                {warnings.length > 0 && (
                    <>
                        <p style={{fontWeight: "bold", color: "red"}}>Warnings - The below warnings do not prevent to upload the file</p>
                        <hr style={{backgroundColor: "red", height: "1px", border: "none"}}/>
                        {warnings.map((warning) => (
                            <>
                                <div className="inline" style={{color: "red", marginRight: "2px"}}> - </div>
                                <div className="inline" style={{color: "red", width: "98%"}}>
                                    {warning}
                                </div>
                                <br/>
                            </>
                        ))}
                    </>
                )}

                <ButtonNavigation
                    setSelectedPage={setSelectedPage}
                    selectedPage={selectedPage}
                    setSelectedCountry={setSelectedCountry}
                    country={country}
                    setSelectedOption={setSelectedOption}
                    selectedOption={selectedOption}
                />
            </div>
        </div>
    );
};

export default FileUploadVerification;
